import {
    CLEAR_GLOBAL_NOTIFICATION,
    NOTIFICATION_SUCCESS,
    SET_GLOBAL_NOTIFICATION
} from "./constants";

export const setGlobalNotification = (message, isOpen, notificationKey = NOTIFICATION_SUCCESS) => ({
    type: SET_GLOBAL_NOTIFICATION,
    payload: {
        message,
        isOpen,
        notificationKey,
    },
});

export const closeGlobalNotification = () => ({
    type: CLEAR_GLOBAL_NOTIFICATION,
    payload: {
        message: '',
        isOpen: false,
        notificationKey: '',
    }
});